import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Col, Container, Row } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "/src/components/Common/Breadcrumb";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import {
  getMessages as onGetMessages,
} from "../../store/actions";

import ChatList from "./ChatList";
import UserChat from "./UserChat";
import i18n from "../../i18n";

const Chat = () => {

  //meta title
  document.title = "Admin Web Chat";

  const dispatch = useDispatch();

  const CommunicationsProperties = createSelector(
    (state) => state.Communications,
    (Communications) => ({
      messages: Communications.messages,
      loading: Communications.loading
    })
  );

  const { messages, loading } = useSelector(CommunicationsProperties);

  const [currentRoomId, setCurrentRoomId] = useState(1);
  const [Chat_Box_Username, setChat_Box_Username] = useState("Steven Franklin");
  const [Chat_Box_User_Status, setChat_Box_User_Status] = useState("online");

  useEffect(() => {
    dispatch(onGetMessages(currentRoomId));
  }, [onGetMessages, currentRoomId]);

  //Use For Chat Box
  const userChatOpen = (chats) => {
    setChat_Box_Username(chats.name);
    setChat_Box_User_Status(chats.status)
    setCurrentRoomId(chats.roomId);
    dispatch(onGetMessages(chats.roomId));
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={i18n.t("Chat")} breadcrumbItem={i18n.t("Communications")} />

          <Row>
            <Col lg="12">
              <div className="d-lg-flex">
                <ChatList
                  userChatOpen={userChatOpen}
                  currentRoomId={currentRoomId} />

                <UserChat
                  Chat_Box_Username={Chat_Box_Username}
                  Chat_Box_User_Status={Chat_Box_User_Status}
                  messages={messages}
                  loading={loading}
                />
              </div>
            </Col>
          </Row >
        </Container >
      </div >
    </React.Fragment >
  );
};

Chat.propTypes = {
  chats: PropTypes.array,
  groups: PropTypes.array,
  contacts: PropTypes.array,
  messages: PropTypes.array,
  onGetChats: PropTypes.func,
  onGetGroups: PropTypes.func,
  onGetContacts: PropTypes.func,
  onGetMessages: PropTypes.func,
  onAddMessage: PropTypes.func,
};

export default Chat;
